import { useTheme } from '@emotion/react';
import {
  Avatar,
  Box,
  Button,
  Card,
  Dialog,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Stack,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
} from '@mui/material';
import Paper from '@mui/material/Paper';
import Popover from '@mui/material/Popover';
import Slide from '@mui/material/Slide';
import { makeStyles } from '@mui/styles';
import { getApiCall } from 'api/apiService';
import Listhome from 'assets/svg/Listhomeicon.svg';
import Monetize from 'assets/icons/dollar.svg';
import BlueTick from 'assets/icons/blueTick.svg';
import { collectId } from 'component/ContactTab/Table';
import { ExpandedBuyersCard } from 'component/ExpandedBuyerCard/ExpandedBuyersCard';
import MessagingContainer from 'component/MessagingContainer/MessagingContainer';
import LiveActivityFeed from 'component/OwnerCard/LiveActivityFeed';
import {
  CloseLayout,
  RightArrow,
  TabPanel,
} from 'component/OwnerCard/OwnerCard';
import { PropertyContext } from 'component/PropertyContext/PropertyContext';
import {
  APP_SCALE,
  DESKTOP_BREAKPOINT,
  GET_BINDERID,
  PROPERTYLIST_COMMON,
} from 'constant/app.config';
import React, { useContext, useEffect, useRef, useState } from 'react';
import Draggable from 'react-draggable';
import {
  displayFlex,
  poppins400,
  poppins500,
  poppins600,
} from 'theme/common.style';
import { BuyerCardProfile } from './BuyerCardProfile';
import {
  BedIcon,
  BuyersActivities,
  CarIcon,
  ShowerIcon,
} from './BuyersActivities';
import './BuyersCard.css';
import BuyerCardNavigationDetails from './BuyerCardNavigationDetails';
import { PauseIcon } from 'component/PropertyTime/PropertyTimer';
import moment from 'moment/moment';
import CountdownTimer from 'component/CountDownTimer/CountdownTimer';
import { Feedback } from './Feedback';
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

export const Arrow2 = () => {
  return (
    <svg
      width="9"
      height="15"
      viewBox="0 0 9 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.11328 13.9956L7.20606 7.90283L1.11328 1.81006"
        stroke="#6C2AD2"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const MarketIcon = ({ color = '#000000' }) => {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.3633 7.23476H21.3543C21.3711 7.16179 21.3633 7.08423 21.3291 7.01525L18.3906 1.09292C18.3351 0.981232 18.2213 0.910645 18.0966 0.910645H3.62997C3.50532 0.910645 3.39146 0.981273 3.33601 1.09292L0.397447 7.01525C0.36324 7.08423 0.355447 7.16179 0.372305 7.23476H0.363281C0.363281 8.18833 0.830941 9.03428 1.54855 9.55674V19.5034C1.54855 19.6846 1.69547 19.8315 1.87668 19.8315H19.8499C20.0311 19.8315 20.178 19.6846 20.178 19.5034V9.55674C20.8956 9.03428 21.3633 8.18829 21.3633 7.23476ZM18.4922 9.4496C17.357 9.4496 16.4191 8.59098 16.2924 7.48918H20.692C20.5653 8.59102 19.6274 9.4496 18.4922 9.4496ZM10.5352 6.83293H6.15936L6.96335 1.56685H10.5352V6.83293ZM11.1914 1.56689H14.7632L15.5672 6.83297H11.1914V1.56689ZM10.5201 7.48918C10.3934 8.59098 9.4555 9.4496 8.32031 9.4496C7.18512 9.4496 6.24718 8.59098 6.12052 7.48918H10.5201ZM15.606 7.48918C15.4794 8.59098 14.5414 9.4496 13.4062 9.4496C12.2711 9.4496 11.3331 8.59098 11.2065 7.48918H15.606ZM20.5061 6.83293H16.231L15.427 1.56689H17.8931L20.5061 6.83293ZM3.83341 1.56689H6.29947L5.49548 6.83297H1.22051L3.83341 1.56689ZM1.03458 7.48918H5.43417C5.30751 8.59098 4.36956 9.4496 3.23438 9.4496C2.09919 9.4496 1.16124 8.59102 1.03458 7.48918ZM9.1195 19.1752H5.28245V13.7881H9.1195V19.1752ZM19.5218 19.1752H9.77575V13.46C9.77575 13.2788 9.62883 13.1319 9.44763 13.1319H4.95437C4.77316 13.1319 4.62624 13.2788 4.62624 13.46V19.1752H2.2048V9.91423C2.52464 10.0376 2.87159 10.1059 3.23438 10.1059C4.33753 10.1059 5.29672 9.48016 5.77734 8.56531C6.25797 9.48016 7.21716 10.1059 8.32031 10.1059C9.42347 10.1059 10.3827 9.48016 10.8633 8.56531C11.3439 9.48016 12.3031 10.1059 13.4062 10.1059C14.5094 10.1059 15.4686 9.48016 15.9492 8.56531C16.4298 9.48016 17.389 10.1059 18.4922 10.1059C18.855 10.1059 19.2019 10.0376 19.5218 9.91423V19.1752ZM16.7238 11.2322H13.5738C13.3926 11.2322 13.2456 11.3791 13.2456 11.5604V14.8416C13.2456 15.0228 13.3926 15.1697 13.5738 15.1697H16.7238C16.905 15.1697 17.0519 15.0228 17.0519 14.8416V11.5604C17.0519 11.3791 16.905 11.2322 16.7238 11.2322ZM16.3956 14.5135H13.9019V11.8885H16.3956V14.5135Z"
        fill={color}
      />
    </svg>
  );
};

const Home = ({ color = '#000000' }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_15615_64182)">
        <path
          d="M21.2038 10.6716L17.3291 7.36277C17.3337 7.34013 17.3382 7.3175 17.3427 7.29034V2.96303C17.3382 2.70502 17.1345 2.4968 16.8765 2.48775H14.7128C14.4639 2.48775 14.2602 2.70955 14.2602 2.96303V4.75552L11.1596 2.11205C10.9921 1.96721 10.7431 1.96721 10.5711 2.11205L0.526864 10.6671C0.332225 10.8255 0.309593 11.1107 0.46802 11.3053C0.626446 11.5 0.911614 11.5226 1.10625 11.3642C1.11078 11.3596 1.11078 11.3596 1.11531 11.3551L10.8653 3.05356L14.3553 6.02746L16.442 7.80183L20.6199 11.3596C20.81 11.5226 21.0952 11.5 21.2581 11.3099C21.4166 11.1197 21.3939 10.8346 21.2038 10.6716ZM16.4329 6.59779L15.1655 5.52954V3.39757H16.4329V6.59779Z"
          fill={color}
        />
        <path
          d="M19.2066 11.5854L17.9346 10.4991L11.1585 4.70971C10.991 4.56486 10.742 4.56486 10.57 4.70971L3.79391 10.4991L2.52197 11.5854C2.33185 11.7484 2.30922 12.0335 2.47218 12.2237C2.6306 12.4138 2.91124 12.4364 3.09683 12.278L3.10136 12.2735L3.66717 11.7846V20.2717C3.67169 20.5252 3.87991 20.7334 4.13339 20.738H17.5906C17.8441 20.7334 18.0523 20.5297 18.0568 20.2717V11.7846L18.6226 12.2735C18.7041 12.3413 18.8037 12.3821 18.9123 12.3821C19.0436 12.3821 19.1703 12.3232 19.2564 12.2237C19.4238 12.029 19.3967 11.7439 19.2066 11.5854ZM12.6749 19.8281H9.05367V14.9395H12.6749V19.8281ZM13.5801 19.8281V14.5005C13.5801 14.2515 13.3946 14.0343 13.1456 14.0343H8.58292C8.33396 14.0343 8.14838 14.2515 8.14838 14.5005V19.8281H4.57246V11.0106L10.8643 5.65122L17.1561 11.0106V19.8281H13.5801Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_15615_64182">
          <rect
            width="21"
            height="21"
            fill="white"
            transform="translate(0.363281 0.870605)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const ToggleOff = () => {
  return (
    <svg
      width="42"
      height="25"
      viewBox="0 0 42 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="gradient" gradientTransform="rotate(90)">
          <stop offset="0%" stop-color="rgba(108, 42, 210, 1)" />
          <stop offset="100%" stop-color="rgba(119, 207, 254, 1)" />
        </linearGradient>
      </defs>
      <rect
        width="41.54"
        x="0.460938"
        y="0.370605"
        height="24.3705"
        rx="12.1852"
        fill="url(#gradient)"
      />

      <ellipse
        cx="12.982"
        cy="12.5558"
        rx="8.52103"
        ry="8.86199"
        fill="white"
      />
    </svg>
  );
};
const BackLeftArrow = () => {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.70689 0.293048C7.89436 0.480744 7.99968 0.735279 7.99968 1.00068C7.99968 1.26608 7.89436 1.52062 7.70689 1.70831L3.41383 6.00515H15C15.2652 6.00515 15.5196 6.1106 15.7071 6.2983C15.8946 6.48601 16 6.74059 16 7.00604C16 7.2715 15.8946 7.52608 15.7071 7.71378C15.5196 7.90148 15.2652 8.00694 15 8.00694H3.41383L7.70689 12.3038C7.88905 12.4925 7.98985 12.7454 7.98757 13.0078C7.98529 13.2702 7.88012 13.5213 7.69471 13.7068C7.5093 13.8924 7.25848 13.9977 6.99628 14C6.73408 14.0022 6.48148 13.9014 6.29287 13.719L0.292791 7.71367C0.105317 7.52598 0 7.27144 0 7.00604C0 6.74064 0.105317 6.48611 0.292791 6.29841L6.29287 0.293048C6.4804 0.10541 6.73471 0 6.99988 0C7.26505 0 7.51936 0.10541 7.70689 0.293048Z"
        fill="#6C2AD2"
      />
    </svg>
  );
};

const Uparrow = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 15 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.52734 7.32446L7.72552 1.33895L13.711 7.53713"
        stroke="#9D9C9E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const Downarrow = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 15 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8086 1.11328L7.71582 7.20606L1.62305 1.11328"
        stroke="#6C2AD2"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const Upactivearrow = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 15 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: 'rotate(180deg)' }}
    >
      <path
        d="M13.8086 1.11328L7.71582 7.20606L1.62305 1.11328"
        stroke="#6C2AD2"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const Downinactivearrow = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 15 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: 'rotate(180deg)' }}
    >
      <path
        d="M1.52734 7.32446L7.72552 1.33895L13.711 7.53713"
        stroke="#9D9C9E"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const Closeicon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="2.09781"
        y1="1"
        x2="15.6836"
        y2="14.5858"
        stroke="#6C2AD2"
        stroke-width="2"
        stroke-linecap="round"
      />
      <line
        x1="1.68359"
        y1="14.5858"
        x2="15.2694"
        y2="1"
        stroke="#6C2AD2"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};
export const BuyersCard = (
  {
    changeToggle,
    setChangeToggle,
    count,
    selectedBuyers,
    setSelectedBuyers,
    selectedBuyerId,
    setSelectedBuyerId,
    isPopupOpen,
    isModalOpen,
    setIsModalOpen,
    buyersId,
    userType,
    openOwner,
    setOpenOwner,
    open,
    setOpen,
    expandFeedback,
    setExpandFeedback,
    checked,
    index,
    setIsHiddenRightArrow,
    isHiddenRightArrow,
    position,
    arrayCollection,
    data,
    setArrayCollection,
    setPosition,
    buyerId,
    setBuyerId,
    setUserType,
    showBackdrop,
    tableData,
    rowData,
    ownercardprop,
    fromSearch,
    catSelected,
    noteSelected,
    taskId,
    taskBinderId,
    setFromSearch,
    onShowChat,
  },
  props
) => {
  const { collapsed } = useContext(PropertyContext);
  const emailId = rowData?.userEmail;
  const [expand, setExpand] = useState(false);
  const [proid, setProid] = useState('');
  const [proUniqueId, setProUniqueId] = useState('');
  const [buyerpropertylist, setBuyerpropertylist] = useState({});
  const [propertyColor, setPropertyColor] = useState('#000000');
  const [marketColor, setMarketColor] = useState('#000000');
  const [value, setValue] = React.useState(0);
  const [expandValue, setExpandValue] = React.useState(0);
  const [propertyValue, setPropertyValue] = React.useState(0);
  const [show, setShow] = useState(false);
  const [marketShow, setMarketShow] = useState(false);
  const [showProperty, setShowProperty] = useState(false);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down(1200));
  const matches370 = useMediaQuery(theme.breakpoints.down(370));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const matches870 = useMediaQuery(theme.breakpoints.down(870));
  const matches1200 = useMediaQuery(theme.breakpoints.down(1200));
  const matches1600 = useMediaQuery(theme.breakpoints.down(1600));
  const isDesktop = useMediaQuery(`(min-width:${DESKTOP_BREAKPOINT}px)`);
  const shrink = useMediaQuery(theme.breakpoints.down(1400));
  const [selectedPaAddressTwo, setSelectedPaAddressTwo] = useState('');
  const [buyerCardDetailNavigation, setBuyerCardDetailNavigation] =
    useState('Profile');
  const [propertySelected, setPropertySelected] = useState(false);
  const [propertySelectedDetail, setPropertySeletedDetail] = useState(null);
  const [isPipelineCat, setIsPipelineCat] = useState(null);
  const [pipelineCat, setPipelineCat] = useState(null);
  const [pipelineId, setPipelineId] = useState(null);
  const [isAppraisal, setIsAppraisal] = useState(null);
  const [openFeedback, setOpenFeedback] = useState(false);
  const [address, setAddress] = useState();
  const [pause, SetPause] = useState();
  const [buyerName, setBuyerName] = useState('');
  const scrollToTopContainer = useRef(null);

  const data1 = localStorage.getItem('userDetail');

  const userDetail = JSON.parse(data1);
  const userId = userDetail?.userId;
  const handleChangePaAddressTwo = (newAddress) => {
    setSelectedPaAddressTwo(newAddress);
  };
  const [anchorPropertyEl, setPropertyAnchorEl] = useState(null);

  const togglePopupShow = (event) => {
    setPropertyAnchorEl(event.currentTarget);
  };

  const handlepropertyClose = () => {
    setPropertyAnchorEl(null);
  };

  const openpropertypopover = Boolean(anchorPropertyEl);
  const propertyid = openpropertypopover ? 'simple-popover' : undefined;

  const [anchorEl, setAnchorEl] = useState(null);
  const [popoverOpen, setPopoverOpen] = useState(false);

  const directcomm = (userId) => {
    const data = localStorage.getItem('userDetail');
    const userDetail = JSON.parse(data);
    const agentId = userDetail?.userId;
    const userType = userDetail?.primaryUserType;

    if (userId) {
      getApiCall(
        GET_BINDERID +
          `/${agentId}` +
          `/${userId}` +
          `/${proid}` +
          `/${userType}`
      ).then((resp) => {
        onShowChat(resp?.data?.binderId);
      });
    }
  };
  //to open expanded card view to show task/note from search results
  useEffect(() => {
    if (taskId || noteSelected) {
      setBuyerCardDetailNavigation('Activity');
    }
  }, []);

  const handleLeftArrowClick = (event) => {
    setPopoverOpen(true);
    setAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const isPopoverOpen = Boolean(anchorEl);
  const popoverId = isPopoverOpen ? 'expanded-buyers-card-popover' : undefined;

  const Timerdetails = ({ item }) => {
    let runningDate = '';

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(item));

    useEffect(() => {
      const timer = setTimeout(() => {
        setTimeLeft(calculateTimeLeft(item));
      }, 1000);

      return () => clearTimeout(timer);
    }, []);
    function calculateTimeLeft(item) {
      if (item?.stage !== 0 && item?.timerStatus === 'Start') {
        const currentTime = moment().valueOf();
        const dateWithStartAtCal = moment(item?.startedAt).format();
        const duration = moment.duration(item?.timerDuration, 'milliseconds');
        runningDate = moment(dateWithStartAtCal).add(duration).toDate();
      } else if (item?.stage !== 0 && item?.timerStatus === 'Pause') {
        SetPause(item?.pausedTimerDuration);
        const currentTime = moment().valueOf();
        const dateWithStartAtCal = moment(item?.pausedAt).format();
        const duration = moment.duration(item?.timerDuration, 'milliseconds');
        const days = duration.days();
        runningDate = moment(dateWithStartAtCal).add(days, 'd').toDate();
      } else {
        const dateWithStartAtCal = moment(item?.startedAt).format();
        const duration = moment.duration(item?.timerDuration, 'milliseconds');
        const days = duration.days();
        runningDate = moment(dateWithStartAtCal).toDate();
      }
    }

    return (
      <CountdownTimer
        advanced={true}
        targetDate={runningDate}
        propertyId={item?.propertyId}
        isUnPublished={false}
        publishcard={true}
        paused={pause}
        pausestatus={item?.timerStatus === 'Pause' ? true : false}
        stage={item?.stage}
        startedAt={item?.startedAt}
        pvstatus={item?.vendorStatus?.status}
      />
    );
  };

  const Propertylist = () => {
    if (buyerId) {
      let url = PROPERTYLIST_COMMON + '/Buyer/' + buyerId;
      getApiCall(url).then((res) => {
        setBuyerpropertylist(res?.data?.data);
        setProid(res?.data?.data[0]?.pd_Id);
        setProUniqueId(res?.data?.data[0]?.pd_propertyId);
        setPipelineId(res?.data?.data?.[0]?.pd_pipelineId);
        setPipelineCat(res?.data?.data?.[0]?.pd_categoryId);
        setIsPipelineCat(res?.data?.data?.[0]?.isPipelineProperty);
        setIsAppraisal(res?.data?.data?.[0]?.pd_isAppraisal);
      });
    }
  };
  useEffect(() => {
    if (!ownercardprop) {
      Propertylist();
    }
  }, [buyerId]);
  var buttonText = show ? (
    <Typography
      sx={{
        fontFamily: 'Poppins !important',
        fontStyle: 'normal !important',
        fontWeight: '600 !important',
        fontSize: '12px',
      }}
    >
      <Grid
        item
        sx={{
          display: 'flex',
          direction: 'row',
          spacing: '2',
          textTransform: 'capitalize',
        }}
      >
        <Grid item sx={{ pr: 1 }}>{`collapse  `}</Grid>
        <Grid item>
          <Arrow2 />
        </Grid>
      </Grid>
    </Typography>
  ) : (
    <Typography
      sx={{
        fontFamily: 'Poppins !important',
        fontStyle: 'normal !important',
        fontWeight: '600 !important',
        fontSize: '12px',
      }}
    >
      <Grid
        item
        sx={{
          display: 'flex',
          direction: 'row',
          spacing: '2',
          textTransform: 'capitalize',
        }}
      >
        {' '}
        <Grid item sx={{ pr: 1 }}>
          expand
        </Grid>{' '}
        <Grid item>
          <Arrow2 />
        </Grid>
      </Grid>
    </Typography>
  );
  function PaperComponent(props) {
    return (
      <Draggable>
        <Paper {...props} />
      </Draggable>
    );
  }

  const [expandAgency, setExpandAgenct] = useState('all');

  const handleExpand = () => {
    setExpand(!expand);
  };
  const handlePropertyChange = (event, propertyValue) => {
    setPropertyValue(propertyValue);
  };

  const isSm = useMediaQuery(theme.breakpoints.down(430));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const Small = useMediaQuery((theme) => theme.breakpoints.only('sm'));
  const isMd = useMediaQuery((theme) => theme.breakpoints.only('md'));
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));
  const isXl = useMediaQuery(theme.breakpoints.down('xl'));
  const isLg = useMediaQuery(theme.breakpoints.down('lg'));
  const useStyles = makeStyles({
    tab: {
      minHeight: '24px', // Set the desired minimum height here
    },
    dialogoverlay: {
      position: 'fixed !important',
      display: 'flex',
      justifyContent: 'end',
      right: '2%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      marginLeft: !collapsed
        ? isXl
          ? '170px'
          : '203px'
        : matches
        ? ''
        : isXl
        ? '70px'
        : '85px',
      marginTop: matchessm ? '0px' : isLg ? '98px' : isXl ? '80px' : '98px',
    },
    dialogoverlayBuyersCards: {
      position: 'fixed !important',
      width: '89%',
      height: matchessm ? '100%' : '90%',
      marginLeft: '16%',
      marginTop: matchessm ? '0px' : '34px',
    },
  });

  const classes = useStyles();
  const handleChange = (event, expandValue) => {
    setValue(expandValue);
  };
  const handleChangeExpand = (event, newValue) => {
    setExpandValue(newValue);
  };
  function toggleShow() {
    setShow(!show);
  }

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  function propertyProps(propIndex) {
    return {
      id: `simple-tab-${propIndex}`,
      'aria-controls': `simple-tabpanel-${propIndex}`,
    };
  }

  var len = arrayCollection?.length;
  var previous = arrayCollection[(position + len - 1) % len];
  var next = arrayCollection[(position + 1) % len];

  const currentPage = window.location.pathname;
  const rightPosition = count * 367;

  useEffect(() => {
    setShow(false);
  }, [expand]);

  const [selectedPaBlue, setSelectedPaBlue] = useState('');
  const handleBlueline = (newBlue) => {
    setSelectedPaBlue(newBlue);
  };
  const extraRightSpace = window.innerWidth > 2000 ? 40 : 0;
  const [loading, setLoading] = useState(false);
  return (
    <>
      <Dialog
        sx={
          showBackdrop
            ? {
                maxWidth: expand ? 'auto' : 'fit-content',
                position: 'relative',
                left: expand ? -60 : window.innerWidth - 200,
              }
            : {}
        }
        style={!matches700 ? { zIndex: 1 } : {}}
        className={
          showBackdrop
            ? classes.dialogoverlayBuyersCards
            : classes.dialogoverlay
        }
        TransitionComponent={Transition}
        hideBackdrop
        disableEnforceFocus
        PaperProps={{
          sx: {
            position: 'absolute',
            top: showBackdrop ? 50 : matchessm ? 0 : 0,
            right: showBackdrop
              ? showBackdrop && changeToggle
                ? 0
                : 300 * (selectedBuyers?.length - (count + 1)) + extraRightSpace
              : 0,
            m: 0,
            height: isDesktop && `calc(90vh / ${APP_SCALE})`,

            maxHeight: isDesktop && `calc(90vh / ${APP_SCALE})`,

            minHeight: !isDesktop && '100%',
            width: matchessm
              ? '100vw'
              : expand && show && !matches1200 && !matches870
              ? '94%'
              : expand && show && matches1200 && !matches870
              ? '92%'
              : expand && !show && shrink && !matches870
              ? '92%'
              : expand && !show && !matches1200 && !matches870
              ? '100%'
              : expand && !show && matches1200 && !matches870
              ? '92%'
              : expand && matches870 && !show
              ? '367px'
              : expand && matches870 && show
              ? '367px'
              : matches370 && expand && show
              ? '350px'
              : matches370 && !expand && !show
              ? '350px'
              : showBackdrop
              ? '500px'
              : '367px',
            overflow: 'unset',
            transition: 'all 0.5s ease',
            boxShadow: 'none',
            paddingBottom: matches700 ? '20px' : '10px',
            transformOrigin: !matchessm && 'top right',
            transform: matchessm && 'none',
          },
        }}
        open={open}
        disableBackdropClick
        minHeight={matchessm ? '100vh' : '100vh'}
        maxWidth="1719px"
      >
        {currentPage.includes('/view-dashboard/1') && !showBackdrop && (
          <div
            style={{
              position: 'absolute',
              left:
                isSm && !show
                  ? -54
                  : expand && window.innerWidth <= 1800
                  ? -60
                  : expand && window.innerWidth <= 1450
                  ? -60
                  : expand && window.innerWidth <= 1200
                  ? -60
                  : expand && window.innerWidth <= 1000
                  ? -40
                  : -80,
              top: -5,
              cursor: 'pointer',
            }}
            onClick={() => {
              setOpen(!open);
              setIsModalOpen(!isModalOpen);
              setSelectedBuyerId('');
              setExpand(false);
            }}
          >
            <CloseLayout color={expand === true ? '#6C2AD2' : '#6C2AD2'} />
          </div>
        )}
        {(currentPage.includes('/People') ||
          currentPage.includes('/dashboard') ||
          currentPage.includes('/pipeline')) &&
          !showBackdrop && (
            <div
              style={{
                position: 'absolute',
                left: matches450
                  ? 0
                  : expand &&
                    show &&
                    window.innerWidth >= 1200 &&
                    expand &&
                    show &&
                    window.innerWidth <= 1450
                  ? -60
                  : expand &&
                    window.innerWidth < 1001 &&
                    window.innerWidth > 869
                  ? -60
                  : -80,
                top: -5,
                cursor: 'pointer',
                paddingBottom: matches450 && '20px',
              }}
            >
              <Grid
                container
                position={position}
                arrayCollection={arrayCollection}
                data={data}
                tableData={tableData}
                setBuyerId={setBuyerId}
                setPosition={setPosition}
                setArrayCollection={setArrayCollection}
                setIsModalOpen={setIsModalOpen}
                isModalOpen={isModalOpen}
                setOpen={setOpen}
                open={open}
                buyerId={buyersId}
                setExpand={setExpand}
                setUserType={setUserType}
                userType={userType}
                sx={{
                  marginTop: matches450 ? '-55px' : '7px',
                  height: matches450
                    ? '53.58px'
                    : ['buyer', 'notes', 'task'].includes(catSelected)
                    ? '60px'
                    : '135.38px',
                  width: matches450 ? window.innerWidth : '53.58px',
                  backgroundColor: 'white',
                  borderRadius: '5px',
                }}
                style={{
                  display: matchessm ? 'none' : 'flex',
                  flexdirection: matches450 ? 'row' : 'column',
                  justifyContent: matches450 ? 'flex-end' : 'center',
                  gap: matches450 && '20px',
                }}
              >
                {!matches450 && (
                  <Grid sx={{ marginTop: '10px' }}>
                    <IconButton
                      onClick={() => {
                        setOpen(!open);
                        setIsModalOpen(!isModalOpen);
                        setExpand(false);
                        setSelectedBuyerId('');
                        setBuyerId('');
                        setBuyerpropertylist({});
                        if (typeof setFromSearch === 'function') {
                          setFromSearch(false);
                        }
                      }}
                    >
                      <Closeicon />{' '}
                    </IconButton>
                  </Grid>
                )}

                {catSelected != 'buyer' &&
                  catSelected !== 'task' &&
                  catSelected !== 'notes' && (
                    <Grid sx={{ marginTop: matches450 ? '10px' : '5px' }}>
                      <IconButton
                        disabled={position === 0}
                        onClick={(e) => {
                          if (
                            position !== 0 &&
                            data[position - 1]?.userCategory[0]?.userType ===
                              'Buyer'
                          ) {
                            collectId(
                              data,
                              previous,
                              setBuyerId,
                              setPosition,
                              setArrayCollection
                            );
                          } else {
                            setOpen(!open);
                            setOpenOwner(true);
                            collectId(
                              data,
                              previous,
                              setBuyerId,
                              setPosition,
                              setArrayCollection
                            );
                          }
                        }}
                      >
                        {position === 0 ? <Uparrow /> : <Upactivearrow />}
                      </IconButton>
                    </Grid>
                  )}

                {catSelected != 'buyer' &&
                  catSelected !== 'task' &&
                  catSelected !== 'notes' && (
                    <Grid sx={{ marginTop: matches450 ? '10px' : '5px' }}>
                      <IconButton
                        disabled={position === len - 1}
                        onClick={(e) => {
                          if (
                            position !== len - 1 &&
                            data[position + 1]?.userCategory[0]?.userType ===
                              'Buyer'
                          ) {
                            collectId(
                              data,
                              next,
                              setBuyerId,
                              setPosition,
                              setArrayCollection
                            );
                          } else {
                            setOpen(!open);
                            setOpenOwner(true);
                            collectId(
                              data,
                              next,
                              setBuyerId,
                              setPosition,
                              setArrayCollection
                            );
                          }
                        }}
                      >
                        {position === len - 1 ? (
                          <Downinactivearrow />
                        ) : (
                          <Downarrow />
                        )}
                      </IconButton>
                    </Grid>
                  )}
                {matches450 && (
                  <Grid
                    sx={{
                      marginTop: '10px',
                      marginRight: matches370
                        ? '20px'
                        : matches450
                        ? '10px'
                        : '',
                    }}
                  >
                    <IconButton
                      onClick={() => {
                        setOpen(!open);
                        setIsModalOpen(!isModalOpen);
                        setExpand(false);
                        setSelectedBuyerId('');
                        setBuyerId('');
                        setBuyerpropertylist({});
                        if (typeof setFromSearch === 'function') {
                          setFromSearch(false);
                        }
                      }}
                    >
                      <Closeicon />{' '}
                    </IconButton>
                  </Grid>
                )}
              </Grid>
            </div>
          )}
        <Stack
          style={{
            display: 'flex',
            flexDirection: matches870 ? 'column' : 'row',
            marginLeft: expand && matches450 && '10px',
            width: '100%',
            overflowY: 'scroll',
            '-webkit-scrollbar': {
              display: 'none',
            },
            '-ms-overflow-style': 'none',
            'scrollbar-width': 'none',
          }}
          ref={scrollToTopContainer}
        >
          {matchessm && !loading && (
            <BuyerCardNavigationDetails
              scrollToTopContainer={scrollToTopContainer}
              setBuyerCardDetailNavigation={setBuyerCardDetailNavigation}
              buyerCardDetailNavigation={buyerCardDetailNavigation}
              setPropertySelected={setPropertySelected}
            />
          )}
          {matchessm && (
            <Stack
              direction="row"
              gap="8px"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                width: '90%',
                margin: matchessm && 'auto',
                marginTop: '23px',
              }}
            >
              {/* Navigation Buttons */}
              <Stack direction="row" gap="8px">
                <Grid
                  sx={{
                    marginTop: '0px',
                    border: '1px solid #E7E5E5',
                    borderRadius: '5px',
                  }}
                >
                  <IconButton
                    disabled={position === 0}
                    onClick={() => {
                      if (
                        position !== 0 &&
                        data[position - 1]?.userCategory[0]?.userType ===
                          'Buyer'
                      ) {
                        collectId(
                          data,
                          previous,
                          setBuyerId,
                          setPosition,
                          setArrayCollection
                        );
                      } else {
                        setOpen(!open);
                        setOpenOwner(true);
                        collectId(
                          data,
                          previous,
                          setBuyerId,
                          setPosition,
                          setArrayCollection
                        );
                      }
                    }}
                  >
                    {position === 0 ? <Uparrow /> : <Upactivearrow />}
                  </IconButton>
                </Grid>
                <Grid
                  sx={{
                    marginTop: '0px',
                    border: '1px solid #E7E5E5',
                    borderRadius: '5px',
                  }}
                >
                  <IconButton
                    disabled={position === len - 1}
                    onClick={() => {
                      if (
                        position !== len - 1 &&
                        data[position + 1]?.userCategory[0]?.userType ===
                          'Buyer'
                      ) {
                        collectId(
                          data,
                          next,
                          setBuyerId,
                          setPosition,
                          setArrayCollection
                        );
                      } else {
                        setOpen(!open);
                        setOpenOwner(true);
                        collectId(
                          data,
                          next,
                          setBuyerId,
                          setPosition,
                          setArrayCollection
                        );
                      }
                    }}
                  >
                    {position === len - 1 ? (
                      <Downinactivearrow />
                    ) : (
                      <Downarrow />
                    )}
                  </IconButton>
                </Grid>
              </Stack>

              {userType === 'Both' && (
                <Stack
                  justifyContent="space-around"
                  direction="row"
                  alignItems="center"
                  spacing={2}
                  sx={{ marginLeft: '2px', margin: '1px', marginTop: '-1px' }}
                >
                  <Typography
                    sx={{
                      ...poppins400,
                      fontSize: '12px',
                      color: '#9C9C9C',
                      marginLeft: '90px',
                    }}
                  >
                    Buyer
                  </Typography>
                  <Typography
                    onClick={() => {
                      setOpen(!open);
                      setOpenOwner(!openOwner);
                    }}
                    style={{
                      cursor: 'pointer',
                      marginTop: '5px',
                      marginLeft: '15px',
                    }}
                  >
                    <ToggleOff />
                  </Typography>
                  <Typography
                    sx={{
                      ...poppins400,
                      fontSize: '12px',
                      color: '#112347',
                      marginLeft: '90px',
                    }}
                  >
                    Owner
                  </Typography>
                </Stack>
              )}

              {/* Close Button */}
              <Grid
                sx={{
                  border: '1px solid #E7E5E5',
                  borderRadius: '5px',
                }}
              >
                <IconButton
                  onClick={() => {
                    setOpen(!open);
                    setIsModalOpen(!isModalOpen);
                    setExpand(false);
                    setSelectedBuyerId('');
                    setBuyerCardDetailNavigation('Profile');
                    setPropertySelected(false);
                    setBuyerId('');
                    setBuyerpropertylist({});
                    if (typeof setFromSearch === 'function') {
                      setFromSearch(false);
                    }
                  }}
                >
                  <Closeicon />
                </IconButton>
              </Grid>
            </Stack>
          )}
          {matchessm && buyerCardDetailNavigation == 'Profile' && (
            <Box
              sx={{
                padding: '0px 10px',
              }}
            >
              <BuyerCardProfile
                setLoading={setLoading}
                loading={loading}
                count={count}
                showBackdrop={showBackdrop}
                selectedBuyers={selectedBuyers}
                setSelectedBuyers={setSelectedBuyers}
                onClose={() => setOpen(false)}
                setSelectedBuyerId={setSelectedBuyerId}
                selectedBuyerId={selectedBuyerId}
                openOwner={openOwner}
                setOpenOwner={setOpenOwner}
                open={open}
                setOpen={setOpen}
                userType={userType}
                buyerId={buyerId}
                onClick={handleExpand}
                setExpand={setExpand}
                expand={expand}
                marketShow={marketShow}
                setMarketShow={setMarketShow}
                show={show}
                setShow={setShow}
                setIsHiddenRightArrow={setIsHiddenRightArrow}
                isHiddenRightArrow={isHiddenRightArrow}
                position={position}
                arrayCollection={arrayCollection}
                data={data}
                setBuyerId={setBuyerId}
                setPosition={setPosition}
                setArrayCollection={setArrayCollection}
                setUserType={setUserType}
                rowData={rowData}
                buyercard={true}
                buyerName={buyerName}
                setBuyerName={setBuyerName}
                fromSearch={fromSearch}
                catSelected={catSelected}
                noteSelected={noteSelected}
                taskId={taskId}
                taskBinderId={taskBinderId}
                proid={proid}
              />
              {!loading && (
                <Box sx={{ marginTop: '15px' }}>
                  <LiveActivityFeed
                    ownercardprop={ownercardprop}
                    buyerId={buyerId}
                    agentindividual={true}
                    rowData={rowData}
                    proid={proid}
                  />
                </Box>
              )}
              {!loading && (
                <Grid
                  sx={{
                    display: 'flex',
                    marginLeft: '75px',
                    padding: '20px',
                    width: '209px',
                    marginBottom: '60px',
                  }}
                >
                  <Typography sx={displayFlex} style={{ gap: '20px' }}>
                    <Typography style={{ paddingRight: '10px' }}>
                      <Button
                        sx={{
                          ...poppins400,
                          fontSize: '12px',
                          color: '#6C2AD2',
                          bgcolor: 'rgba(108, 42, 210, 0.1)',
                          borderRadius: '4.05125px',
                          height: '30px',
                        }}
                        onClick={() => {
                          setOpenFeedback(true);
                        }}
                      >
                        Feedback
                      </Button>
                    </Typography>
                    <Typography>
                      <Select
                        sx={{
                          ...poppins500,
                          fontSize: '12px',
                          color: '#6C2AD2',
                          border: '1px solid #6C2AD2',
                          marginLeft: '10px',
                          height: '30px',
                          background: '#FFFFFF',
                          boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)',
                          borderRadius: '5px',
                          '& .MuiOutlinedInput-notchedOutline': {
                            border: 'none',
                          },
                        }}
                        size="small"
                        value="10"
                        style={{
                          padding: '0px 2px',
                        }}
                        onChange={() => {}}
                        displayEmpty
                        inputProps={{ 'aria-label': 'Without label' }}
                      >
                        <MenuItem value={10}>Action</MenuItem>
                        <MenuItem value={20}>Twenty</MenuItem>
                        <MenuItem value={30}>Thirty</MenuItem>
                      </Select>
                    </Typography>
                  </Typography>
                </Grid>
              )}
            </Box>
          )}
          {matchessm && buyerCardDetailNavigation == 'Activity' && (
            <Box
              sx={{
                padding: '0px 10px',
                width: '100%',
              }}
            >
              <Box
                sx={{
                  width: matchessm ? '100%' : 'auto',
                  height: '110px',
                  position: 'relative',
                }}
              >
                <Stack
                  sx={{
                    width: matchessm ? '100%' : '327px',
                    height: '67px',
                    marginTop: '20px',
                    borderRadius: '10px',
                    background: `linear-gradient(180deg, rgba(108, 42, 210, 0.5) 0%, rgba(117, 184, 247, 0.5) 100%)`,
                  }}
                  justifyContent={'center'}
                  alignItems={'center'}
                  display={'-webkit-inline-flex'}
                >
                  {rowData?.user?.userProfile == '' ||
                  rowData?.user?.userProfile == null ? (
                    <Avatar
                      style={{
                        height: '91px',
                        width: '91px',
                        border: '4px solid #FFFFFF',
                        marginTop: '60px',
                        backgroundColor: '#666666',
                        fontFamily: 'poppins',
                        fontSize: '40px',
                      }}
                    >
                      {rowData?.user?.userName?.charAt(0)?.toUpperCase() +
                        rowData?.user?.userSurName?.charAt(0)?.toUpperCase()}
                    </Avatar>
                  ) : (
                    <Avatar
                      style={{
                        height: '91px',
                        width: '91px',
                        border: '4px solid #FFFFFF',
                        marginTop: '60px',
                      }}
                      src={rowData?.user?.userProfile}
                    />
                  )}
                </Stack>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: '0px',
                  gap: '13px',
                  width: matchessm ? '100%' : '335px',
                  height: '30px',
                  marginTop: '30px',
                }}
              >
                <Typography
                  sx={{ ...poppins600, fontSize: '20px', color: '#000000' }}
                >
                  {buyerName}
                </Typography>
                <Box>
                  <Avatar
                    alt=""
                    src={BlueTick}
                    sx={{ height: '16px', width: '16px' }}
                  />
                </Box>
                <Box>
                  <Avatar
                    alt=""
                    src={Monetize}
                    sx={{ height: '16px', width: '16px' }}
                  />
                </Box>
              </Box>
              <ExpandedBuyersCard
                handleClosePopover={handleClosePopover}
                popover={true}
                isSmall={isSm}
                marketShow={marketShow}
                expandFeedback={expandFeedback}
                setExpandFeedback={setExpandFeedback}
                propertyValue={propertyValue}
                show={show}
                setShow={setShow}
                expand={expand}
                setExpand={setExpand}
                shrink={shrink}
                buyerId={buyerId}
                rowData={rowData}
                buyerpropertylist={buyerpropertylist}
                activitywidth
                proid={proid}
                setProid={setProid}
                userEmail={rowData?.buyerDetails?.userEmail}
                userType={rowData?.buyerDetails?.userCategory[0]?.userType}
                proUniqueId={proUniqueId}
                setProUniqueId={setProUniqueId}
                selectedPaAddressTwo={selectedPaAddressTwo}
                setSelectedPaAddressTwo={setSelectedPaAddressTwo}
                username={rowData?.user}
                handleBlueline={handleBlueline}
                setIsPipelineCat={setIsPipelineCat}
                setPipelineCat={setPipelineCat}
                setPipelineId={setPipelineId}
                setIsAppraisal={setIsAppraisal}
                fromSearch={fromSearch}
                catSelected={catSelected}
                noteSelected={noteSelected}
                taskId={taskId}
                taskBinderId={taskBinderId}
              />
            </Box>
          )}
          {matchessm &&
            buyerCardDetailNavigation == 'Offers' &&
            !propertySelected && (
              <Box sx={{ padding: '0px 10px' }}>
                <Box
                  sx={{
                    width: matchessm ? '100%' : 'auto',
                    height: '110px',
                    position: 'relative',
                  }}
                >
                  <Stack
                    sx={{
                      width: matchessm ? '100%' : '327px',
                      height: '67px',
                      marginTop: '20px',
                      borderRadius: '10px',
                      background: `linear-gradient(180deg, rgba(108, 42, 210, 0.5) 0%, rgba(117, 184, 247, 0.5) 100%)`,
                    }}
                    justifyContent={'center'}
                    alignItems={'center'}
                    display={'-webkit-inline-flex'}
                  >
                    {rowData?.user?.userProfile == '' ||
                    rowData?.user?.userProfile == null ? (
                      <Avatar
                        style={{
                          height: '91px',
                          width: '91px',
                          border: '4px solid #FFFFFF',
                          marginTop: '60px',
                          backgroundColor: '#666666',
                          fontSize: '40px',
                          fontFamily: 'poppins',
                        }}
                      >
                        {rowData?.user?.userName.charAt(0)?.toUpperCase() +
                          rowData?.user?.userSurName.charAt(0)?.toUpperCase()}
                      </Avatar>
                    ) : (
                      <Avatar
                        style={{
                          height: '91px',
                          width: '91px',
                          border: '4px solid #FFFFFF',
                          marginTop: '60px',
                        }}
                        src={rowData?.user?.userProfile}
                      />
                    )}
                  </Stack>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '0px',
                    gap: '13px',
                    width: matchessm ? '100%' : '335px',
                    height: '30px',
                    marginTop: '30px',
                  }}
                >
                  <Typography
                    sx={{ ...poppins600, fontSize: '20px', color: '#000000' }}
                  >
                    {buyerName}
                  </Typography>
                  <Box>
                    <Avatar
                      alt=""
                      src={BlueTick}
                      sx={{ height: '16px', width: '16px' }}
                    />
                  </Box>
                  <Box>
                    <Avatar
                      alt=""
                      src={Monetize}
                      sx={{ height: '16px', width: '16px' }}
                    />
                  </Box>
                </Box>
                <div style={{ width: '100%', paddingTop: '50px' }}>
                  <Box
                    sx={{
                      width: '100%',
                      bgcolor: 'background.paper',
                      height: '24px',
                    }}
                  >
                    <Tabs
                      value={propertyValue}
                      onChange={handlePropertyChange}
                      aria-label=" tabs example"
                      centered
                      sx={{
                        '& .MuiTabs-indicator': { display: 'none' },
                        '& .MuiTab-root.Mui-selected': {
                          background: ' #6C2AD2',
                          borderRadius: '5px',
                          color: '#FFFFFF',

                          gap: '10px',
                        },
                        '& button.Mui-selected': {
                          padding: isXs || Small || isMd ? 'none' : '0px 10px',
                        },
                      }}
                    >
                      <Tab
                        onClick={() => setExpandAgenct('all')}
                        style={{ minHeight: '24px', padding: '0px' }}
                        className={classes.tab}
                        {...propertyProps(1)}
                        label={
                          <Typography
                            sx={{
                              fontFamily: 'Poppins !important',
                              fontStyle: 'normal !important',
                              fontWeight: '400',
                              fontSize: '16px',
                            }}
                          >
                            All
                          </Typography>
                        }
                      />
                      <Tab
                        onClick={() => setExpandAgenct('agency')}
                        style={{ minHeight: '24px', padding: '0px' }}
                        className={classes.tab}
                        {...propertyProps(0)}
                        label={
                          <Typography
                            sx={{
                              fontFamily: 'Poppins !important',
                              fontStyle: 'normal !important',
                              fontWeight: '500',
                              fontSize: '16px',
                            }}
                          >
                            Agency
                          </Typography>
                        }
                      />
                    </Tabs>
                  </Box>
                  <Tabs
                    style={{
                      color: 'purpleHeart',
                      borderBottom: 'purpleheart',
                      display: 'false',
                      marginLeft: '20px',
                    }}
                    value={value}
                    onChange={handleChange}
                    variant="fullWidth"
                    aria-label="full width tabs example"
                    sx={{
                      '& .MuiTabs-indicator': {
                        backgroundColor: '#6C2AD2',
                        marginBottom: '5px',
                      },
                      '& .MuiTab-root.Mui-selected': {
                        color: '#6C2AD2',
                        fontWeight: '500',
                      },
                    }}
                  >
                    <Tab
                      label="All"
                      {...a11yProps(0)}
                      sx={{
                        fontFamily: 'Poppins !important',
                        fontStyle: 'normal !important',
                        fontWeight: '400 !important',
                        fontSize: '12px',
                        textTransform: 'capitalize',
                      }}
                    />

                    <Tab
                      label="Offers"
                      {...a11yProps(1)}
                      sx={{
                        fontFamily: 'Poppins !important',
                        fontStyle: 'normal !important',
                        fontWeight: '400 !important',
                        fontSize: '12px',
                        textTransform: 'none',
                      }}
                    />

                    <Tab
                      label="Inspected"
                      {...a11yProps(2)}
                      sx={{
                        fontFamily: 'Poppins !important',
                        fontStyle: 'normal !important',
                        fontWeight: '400 !important',
                        fontSize: '12px',
                        textTransform: 'none',
                      }}
                    />
                  </Tabs>
                  <TabPanel
                    value={value}
                    index={0}
                    width={matchessm ? '100%' : '340px'}
                  >
                    <BuyersActivities
                      scrollToTopContainer={scrollToTopContainer}
                      setBuyerDetailNavigation={setBuyerCardDetailNavigation}
                      setPropertySelected={setPropertySelected}
                      setPropertySeletedDetail={setPropertySeletedDetail}
                      propertySelectedDetail={propertySelectedDetail}
                      popover={true}
                      buyerId={buyerId}
                      buyerpropertylist={buyerpropertylist}
                      proid={proid}
                      setProid={setProid}
                      proUniqueId={proUniqueId}
                      setProUniqueId={setProUniqueId}
                      expandAgency={expandAgency}
                      index={0}
                      handlepropertyClose={handlepropertyClose}
                      handleChangePaAddressTwo={handleChangePaAddressTwo}
                      selectedPaBlue={selectedPaBlue}
                      setSelectedPaBlue={setSelectedPaBlue}
                    />
                  </TabPanel>
                  <TabPanel value={value} index={1}>
                    <BuyersActivities
                      scrollToTopContainer={scrollToTopContainer}
                      setBuyerDetailNavigation={setBuyerCardDetailNavigation}
                      setPropertySelected={setPropertySelected}
                      setPropertySeletedDetail={setPropertySeletedDetail}
                      propertySelectedDetail={propertySelectedDetail}
                      popover={true}
                      buyerId={buyerId}
                      buyerpropertylist={buyerpropertylist}
                      proid={proid}
                      setProid={setProid}
                      proUniqueId={proUniqueId}
                      setProUniqueId={setProUniqueId}
                      expandAgency={expandAgency}
                      index={1}
                      handlepropertyClose={handlepropertyClose}
                      handleChangePaAddressTwo={handleChangePaAddressTwo}
                      selectedPaBlue={selectedPaBlue}
                      setSelectedPaBlue={setSelectedPaBlue}
                    />
                  </TabPanel>
                  <TabPanel value={value} index={2}>
                    <BuyersActivities
                      scrollToTopContainer={scrollToTopContainer}
                      setBuyerDetailNavigation={setBuyerCardDetailNavigation}
                      setPropertySelected={setPropertySelected}
                      setPropertySeletedDetail={setPropertySeletedDetail}
                      propertySelectedDetail={propertySelectedDetail}
                      popover={true}
                      buyerId={buyerId}
                      buyerpropertylist={buyerpropertylist}
                      proid={proid}
                      setProid={setProid}
                      proUniqueId={proUniqueId}
                      setProUniqueId={setProUniqueId}
                      expandAgency={expandAgency}
                      index={2}
                      handlepropertyClose={handlepropertyClose}
                      handleChangePaAddressTwo={handleChangePaAddressTwo}
                      selectedPaBlue={selectedPaBlue}
                      setSelectedPaBlue={setSelectedPaBlue}
                    />
                  </TabPanel>
                </div>
              </Box>
            )}
          {matchessm &&
            buyerCardDetailNavigation == 'Offers' &&
            propertySelected && (
              <Box sx={{ padding: '0px 10px' }}>
                <Box
                  sx={{
                    width: matchessm ? '100%' : 'auto',
                    height: '110px',
                    position: 'relative',
                  }}
                >
                  <Stack
                    sx={{
                      width: matchessm ? '100%' : '327px',
                      height: '67px',
                      marginTop: '20px',
                      borderRadius: '10px',
                      background: `linear-gradient(180deg, rgba(108, 42, 210, 0.5) 0%, rgba(117, 184, 247, 0.5) 100%)`,
                    }}
                    justifyContent={'center'}
                    alignItems={'center'}
                    display={'-webkit-inline-flex'}
                  >
                    {rowData?.user?.userProfile == '' ||
                    rowData?.user?.userProfile == null ? (
                      <Avatar
                        style={{
                          height: '91px',
                          width: '91px',
                          border: '4px solid #FFFFFF',
                          marginTop: '60px',
                          backgroundColor: '#666666',
                          fontSize: '40px',
                          fontFamily: 'poppins',
                        }}
                      >
                        {rowData?.user?.userName.charAt(0)?.toUpperCase() +
                          rowData?.user?.userSurName.charAt(0)?.toUpperCase()}
                      </Avatar>
                    ) : (
                      <Avatar
                        style={{
                          height: '91px',
                          width: '91px',
                          border: '4px solid #FFFFFF',
                          marginTop: '60px',
                        }}
                        src={rowData?.user?.userProfile}
                      />
                    )}
                  </Stack>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '0px',
                    gap: '13px',
                    width: matchessm ? '100%' : '335px',
                    height: '30px',
                    marginTop: '30px',
                  }}
                >
                  <Typography
                    sx={{ ...poppins600, fontSize: '20px', color: '#000000' }}
                  >
                    {buyerName}
                  </Typography>
                  <Box>
                    <Avatar
                      alt=""
                      src={BlueTick}
                      sx={{ height: '16px', width: '16px' }}
                    />
                  </Box>
                  <Box>
                    <Avatar
                      alt=""
                      src={Monetize}
                      sx={{ height: '16px', width: '16px' }}
                    />
                  </Box>
                </Box>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  sx={{
                    cursor: 'pointer',
                    marginTop: '20px',
                    paddingLeft: '0px',
                  }}
                >
                  <BackLeftArrow />
                  <Typography
                    sx={{
                      ...poppins400,
                      fontSize: '14px',
                      color: '#6C2AD2',
                      marginLeft: '10px',
                    }}
                    onClick={() => {
                      setBuyerCardDetailNavigation('Offers');
                      setPropertySelected(false);
                      setPropertySeletedDetail({});
                    }}
                  >
                    Back to List
                  </Typography>
                </Stack>
                <Card
                  variant="outlined"
                  sx={{
                    width: '100%',
                    minHeight: '138px',
                    border: '0',
                    padding: '0px',
                    borderRadius: '8px',
                    borderLeft: '8px solid #6C2AD2',
                    boxShadow: '0px 1px 6px 0px  rgba(0, 0, 0, 0.15)',
                    marginTop: '10px',
                  }}
                >
                  <Stack direction={'row'}>
                    <Grid
                      container
                      direction={'row'}
                      sx={{
                        alignItems: 'center',
                        padding: '10px',
                        gap: matchessm ? '15px' : '20px',
                        background: ' #FAF8F8',
                        borderRadius: '0px 8px 8px 0px',
                        flexWrap: 'nowrap',
                        display: 'flex',
                        justifyContent: 'flex-start',
                        cursor: 'pointer',
                        width: '95%',
                      }}
                    >
                      <Grid
                        item
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          alignItems: 'flex-start',
                          padding: '0px',
                          gap: '10px',
                          width: matchessm ? '50%' : '166px',
                          minHeight: '118px',
                        }}
                      >
                        <Grid
                          sx={{
                            alignItems: 'flex-start',
                            padding: '0px',
                            gap: '5px',
                            width: matchessm ? '100%' : '166px',
                            minHeight: '43px',
                          }}
                        >
                          <Grid
                            sx={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                              gap: '5px',
                              width: '100%',
                            }}
                          >
                            <Button
                              size="small"
                              sx={{
                                fontSize:
                                  propertySelectedDetail?.isReset == '0'
                                    ? '12px'
                                    : '10px',
                                fontWeight: 600,
                                fontFamily: 'poppins',
                                color: '#FFFFFF',
                                width:
                                  propertySelectedDetail?.isReset == '0'
                                    ? '74px'
                                    : '177px',
                                height: '20px',
                                borderRadius: '2px',
                                backgroundColor:
                                  propertySelectedDetail?.timerStatus == 'End'
                                    ? '#585858'
                                    : propertySelectedDetail?.stage == 'ST1'
                                    ? '#10D35E'
                                    : propertySelectedDetail?.stage == 'ST2' &&
                                      '#F93939',
                                '&:hover': {
                                  backgroundColor:
                                    propertySelectedDetail?.timerStatus == 'End'
                                      ? '#585858'
                                      : propertySelectedDetail?.stage == 'ST1'
                                      ? '#10D35E'
                                      : propertySelectedDetail?.stage ==
                                          'ST2' && '#F93939', // set the hover color to be the same as the regular color
                                },
                              }}
                            >
                              {' '}
                              {propertySelectedDetail?.timerStatus == 'End'
                                ? 'ENDED'
                                : propertySelectedDetail?.stage == 'ST1'
                                ? 'STAGE 1'
                                : propertySelectedDetail?.isReset == '0'
                                ? 'STAGE 2'
                                : 'STAGE 2 - FINAL OFFERS'}
                            </Button>
                            {propertySelectedDetail?.timerStatus == 'Pause' && (
                              <Box sx={{ paddingTop: '6px' }}>
                                <PauseIcon width={21} height={21} />
                              </Box>
                            )}
                          </Grid>
                          <Box
                            sx={{
                              width: '100%',
                              minHeight: '18px',
                              alignSelf: 'stretch',
                              p: '0px',
                              mt: '5px',
                            }}
                          >
                            <Typography
                              sx={{
                                ...poppins500,
                                fontSize: '12px',
                                color: '#200E32',
                                width: '100%',
                                whiteSpace: 'nowrap',
                                overflow: matchessm && 'hidden',
                                textOverflow: 'ellipsis',
                                display: 'block',
                              }}
                            >
                              {propertySelectedDetail?.address}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            aligntems: 'flex-start',
                            padding: '0px',
                            gap: '10px',
                            width: matchessm ? '100%' : '166px',
                            height: '40px',
                            marginTop: '-13px',
                          }}
                        >
                          <Grid
                            sx={{
                              display: 'flex',
                              flexDirection: 'row',
                              justifyContent: 'flex-start',
                              alignItems: 'flex-start',
                              padding: '0px',
                              gap: matchessm ? '8px' : '15px',

                              width: matchessm ? '100%' : '166px',
                              height: '15px',
                            }}
                          >
                            <Box>
                              <Typography
                                sx={{
                                  ...poppins500,
                                  fontSize: '10px',
                                  color: '#200E32',
                                }}
                              >
                                Status :
                              </Typography>
                              <Typography
                                sx={{
                                  ...poppins400,
                                  fontSize: '10px',
                                  color: '#666666',
                                }}
                              >
                                {` ${propertySelectedDetail?.status}`}
                              </Typography>
                            </Box>
                            <Box>
                              <Typography
                                sx={{
                                  ...poppins500,
                                  fontSize: '10px',
                                  color: '#200E32',
                                }}
                              >
                                D.O.M :
                              </Typography>
                              <Typography
                                sx={{
                                  ...poppins400,
                                  fontSize: '10px',
                                  color: '#666666',
                                }}
                              >
                                {` ${propertySelectedDetail?.dom}`}
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid
                            sx={{
                              display: 'flex',
                              flexDirection: 'row',
                              justifyContent: 'center',
                              alignItems: 'center',
                              padding: '10px',
                              gap: '10px',

                              width: '68px',
                              height: '20px',

                              background: '#FFE512',
                            }}
                          >
                            <Typography
                              sx={{
                                ...poppins500,
                                fontSize: '10px',
                                color: '#666666',
                              }}
                            >
                              RayWhite
                            </Typography>
                          </Grid>
                        </Grid>
                        <Grid
                          sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'flex-start',
                            padding: '0px',
                            gap: '5px',

                            width: '120px',
                            height: ' 15px',
                          }}
                        >
                          <Typography
                            sx={{
                              ...poppins500,
                              fontSize: '10px',
                              color: '#200E32',
                            }}
                          >
                            Agent:
                          </Typography>
                          <Typography
                            sx={{
                              ...poppins400,
                              fontSize: '10px',
                              color: '#666666',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {propertySelectedDetail?.agentId === userId
                              ? `${propertySelectedDetail?.agentName}(You)`
                              : `${propertySelectedDetail?.agentName}(Not You)`}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid
                        item
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          padding: '14px 0px 0px',
                          gap: '5px',
                          width: matchessm ? '40%' : '134px',
                        }}
                      >
                        <Stack
                          direction={'row'}
                          alignItems={'center'}
                          spacing={2}
                        >
                          <Stack
                            direction={'row'}
                            justifyContent={'center'}
                            alignItems={'center'}
                            spacing={1}
                          >
                            <Box>
                              <BedIcon />
                            </Box>
                            <Typography
                              sx={{
                                ...poppins500,
                                fontSize: '10px',
                                color: '#666666',
                              }}
                            >
                              {5}
                            </Typography>
                          </Stack>
                          <Stack
                            direction={'row'}
                            justifyContent={'center'}
                            alignItems={'center'}
                            spacing={1}
                          >
                            <Box>
                              <ShowerIcon />
                            </Box>
                            <Typography
                              sx={{
                                ...poppins500,
                                fontSize: '10px',
                                color: '#666666',
                              }}
                            >
                              {5}
                            </Typography>
                          </Stack>
                          <Stack
                            direction={'row'}
                            justifyContent={'center'}
                            alignItems={'center'}
                            spacing={1}
                          >
                            <Box>
                              <CarIcon />
                            </Box>
                            <Typography
                              sx={{
                                ...poppins500,
                                fontSize: '10px',
                                color: '#666666',
                              }}
                            >
                              {5}
                            </Typography>
                          </Stack>
                        </Stack>
                        <Grid>
                          <Box>
                            <Typography
                              sx={{
                                ...poppins500,
                                fontSize: '24px',
                                color: '#262626',
                              }}
                            >
                              <Timerdetails item={propertySelectedDetail} />
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Stack>
                </Card>
                <ExpandedBuyersCard
                  handleClosePopover={handleClosePopover}
                  popover={true}
                  isSmall={isSm}
                  marketShow={marketShow}
                  expandFeedback={expandFeedback}
                  setExpandFeedback={setExpandFeedback}
                  propertyValue={propertyValue}
                  show={show}
                  setShow={setShow}
                  expand={expand}
                  setExpand={setExpand}
                  shrink={shrink}
                  buyerId={buyerId}
                  rowData={rowData}
                  buyerpropertylist={buyerpropertylist}
                  activitywidth
                  proid={proid}
                  setProid={setProid}
                  userEmail={rowData?.buyerDetails?.userEmail}
                  userType={rowData?.buyerDetails?.userCategory[0]?.userType}
                  proUniqueId={proUniqueId}
                  setProUniqueId={setProUniqueId}
                  selectedPaAddressTwo={selectedPaAddressTwo}
                  setSelectedPaAddressTwo={setSelectedPaAddressTwo}
                  username={rowData?.user}
                  handleBlueline={handleBlueline}
                  setIsPipelineCat={setIsPipelineCat}
                  setPipelineCat={setPipelineCat}
                  setPipelineId={setPipelineId}
                  setIsAppraisal={setIsAppraisal}
                  fromSearch={fromSearch}
                  catSelected={catSelected}
                  noteSelected={noteSelected}
                  taskId={taskId}
                  taskBinderId={taskBinderId}
                />
              </Box>
            )}

          {matches870 && (
            <Popover
              id={popoverId}
              open={isPopoverOpen}
              anchorEl={anchorEl}
              onClose={handleClosePopover}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              PaperProps={{
                style: {
                  height: matches700 ? '81%' : '90%',
                  minWidth: matches450 ? '100%' : '100vw',
                  marginTop: '123px',
                },
                sx: {
                  right: 0,
                  bottom: 'unset !important',
                  left: 'unset !important',
                  top: 'unset !important',
                  paddingBottom: 'calc(100px + 1em)',
                },
              }}
            >
              <Grid>
                <Box
                  sx={{ mt: '20px', ml: '25px', mb: '-56px', width: '50px' }}
                  onClick={togglePopupShow}
                >
                  <img
                    src={Listhome}
                    alt="ListhomeImg"
                    height={'30px'}
                    width={'31px'}
                    style={{ borderRadius: '6px' }}
                  />
                </Box>
                <ExpandedBuyersCard
                  handleClosePopover={handleClosePopover}
                  popover={true}
                  isSmall={isSm}
                  marketShow={marketShow}
                  expandFeedback={expandFeedback}
                  setExpandFeedback={setExpandFeedback}
                  propertyValue={propertyValue}
                  show={show}
                  setShow={setShow}
                  expand={expand}
                  setExpand={setExpand}
                  shrink={shrink}
                  buyerId={buyerId}
                  rowData={rowData}
                  buyerpropertylist={buyerpropertylist}
                  activitywidth
                  proid={proid}
                  setProid={setProid}
                  userEmail={rowData?.buyerDetails?.userEmail}
                  userType={rowData?.buyerDetails?.userCategory[0]?.userType}
                  proUniqueId={proUniqueId}
                  setProUniqueId={setProUniqueId}
                  selectedPaAddressTwo={selectedPaAddressTwo}
                  setSelectedPaAddressTwo={setSelectedPaAddressTwo}
                  username={rowData?.user}
                  handleBlueline={handleBlueline}
                  setIsPipelineCat={setIsPipelineCat}
                  setPipelineCat={setPipelineCat}
                  setPipelineId={setPipelineId}
                  setIsAppraisal={setIsAppraisal}
                  fromSearch={fromSearch}
                  catSelected={catSelected}
                  noteSelected={noteSelected}
                  taskId={taskId}
                  taskBinderId={taskBinderId}
                />
                <Popover
                  id={propertyid}
                  open={openpropertypopover}
                  anchorEl={anchorPropertyEl}
                  onClose={handlepropertyClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                  }}
                  PaperProps={{
                    style: {
                      height: matches700 ? '81%' : '90%',
                      minWidth: matches450 ? '100%' : '100vw',
                      marginTop: '123px',
                    },
                    sx: {
                      right: 0,
                      bottom: 'unset !important',
                      left: 'unset !important',
                      top: 'unset !important',
                      paddingBottom: 'calc(100px + 1em)',
                    },
                  }}
                >
                  <Grid
                    sx={{
                      mt: '20px',
                      ml: matches450 ? '87%' : matches700 ? '90%' : '93%',
                      mb: '-56px',
                      width: '50px',
                    }}
                    onClick={handlepropertyClose}
                  >
                    {' '}
                    <RightArrow />
                  </Grid>

                  <div
                    style={{
                      width: matches450 ? '90%' : '100%',
                      paddingTop: '50px',
                      marginLeft: '6px',
                    }}
                  >
                    <Box
                      sx={{
                        width: '100%',
                        bgcolor: 'background.paper',

                        height: '24px',
                      }}
                    >
                      <Tabs
                        value={propertyValue}
                        onChange={handlePropertyChange}
                        aria-label=" tabs example"
                        centered
                        sx={{
                          '& .MuiTabs-indicator': { display: 'none' },
                          '& .MuiTab-root.Mui-selected': {
                            background: ' #6C2AD2',
                            borderRadius: '5px',
                            color: '#FFFFFF',

                            gap: '10px',
                          },
                          '& button.Mui-selected': {
                            padding:
                              isXs || Small || isMd ? 'none' : '0px 10px',
                          },
                        }}
                      >
                        <Tab
                          onClick={() => setExpandAgenct('all')}
                          style={{ minHeight: '24px', padding: '0px' }}
                          className={classes.tab}
                          {...propertyProps(1)}
                          label={
                            <Typography
                              sx={{
                                fontFamily: 'Poppins !important',
                                fontStyle: 'normal !important',
                                fontWeight: '400',
                                fontSize: '16px',
                              }}
                            >
                              All
                            </Typography>
                          }
                        />
                        <Tab
                          onClick={() => setExpandAgenct('agency')}
                          style={{ minHeight: '24px', padding: '0px' }}
                          className={classes.tab}
                          {...propertyProps(0)}
                          label={
                            <Typography
                              sx={{
                                fontFamily: 'Poppins !important',
                                fontStyle: 'normal !important',
                                fontWeight: '500',
                                fontSize: '16px',
                              }}
                            >
                              Agency
                            </Typography>
                          }
                        />
                      </Tabs>
                    </Box>
                    <Tabs
                      style={{
                        color: 'purpleHeart',
                        borderBottom: 'purpleheart',
                        display: 'false',
                        marginLeft: '20px',
                      }}
                      value={value}
                      onChange={handleChange}
                      variant="fullWidth"
                      aria-label="full width tabs example"
                      sx={{
                        '& .MuiTabs-indicator': {
                          backgroundColor: '#6C2AD2',
                          marginBottom: '5px',
                        },
                        '& .MuiTab-root.Mui-selected': {
                          color: '#6C2AD2',
                          fontWeight: '500',
                        },
                      }}
                    >
                      <Tab
                        label="All"
                        {...a11yProps(0)}
                        sx={{
                          fontFamily: 'Poppins !important',
                          fontStyle: 'normal !important',
                          fontWeight: '400 !important',
                          fontSize: '12px',
                          textTransform: 'capitalize',
                        }}
                      />

                      <Tab
                        label="Offers"
                        {...a11yProps(1)}
                        sx={{
                          fontFamily: 'Poppins !important',
                          fontStyle: 'normal !important',
                          fontWeight: '400 !important',
                          fontSize: '12px',
                          textTransform: 'none',
                        }}
                      />

                      <Tab
                        label="Inspected"
                        {...a11yProps(2)}
                        sx={{
                          fontFamily: 'Poppins !important',
                          fontStyle: 'normal !important',
                          fontWeight: '400 !important',
                          fontSize: '12px',
                          textTransform: 'none',
                        }}
                      />
                    </Tabs>
                    <TabPanel value={value} index={0} width="340px">
                      <BuyersActivities
                        scrollToTopContainer={scrollToTopContainer}
                        setBuyerDetailNavigation={setBuyerCardDetailNavigation}
                        setPropertySelected={setPropertySelected}
                        setPropertySeletedDetail={setPropertySeletedDetail}
                        propertySelectedDetail={propertySelectedDetail}
                        popover={true}
                        buyerId={buyerId}
                        buyerpropertylist={buyerpropertylist}
                        proid={proid}
                        setProid={setProid}
                        proUniqueId={proUniqueId}
                        setProUniqueId={setProUniqueId}
                        expandAgency={expandAgency}
                        index={0}
                        handlepropertyClose={handlepropertyClose}
                        handleChangePaAddressTwo={handleChangePaAddressTwo}
                        selectedPaBlue={selectedPaBlue}
                        setSelectedPaBlue={setSelectedPaBlue}
                      />
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                      <BuyersActivities
                        scrollToTopContainer={scrollToTopContainer}
                        setBuyerDetailNavigation={setBuyerCardDetailNavigation}
                        setPropertySelected={setPropertySelected}
                        setPropertySeletedDetail={setPropertySeletedDetail}
                        propertySelectedDetail={propertySelectedDetail}
                        popover={true}
                        buyerId={buyerId}
                        buyerpropertylist={buyerpropertylist}
                        proid={proid}
                        setProid={setProid}
                        proUniqueId={proUniqueId}
                        setProUniqueId={setProUniqueId}
                        expandAgency={expandAgency}
                        index={1}
                        handlepropertyClose={handlepropertyClose}
                        handleChangePaAddressTwo={handleChangePaAddressTwo}
                        selectedPaBlue={selectedPaBlue}
                        setSelectedPaBlue={setSelectedPaBlue}
                      />
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                      <BuyersActivities
                        scrollToTopContainer={scrollToTopContainer}
                        setBuyerDetailNavigation={setBuyerCardDetailNavigation}
                        setPropertySelected={setPropertySelected}
                        setPropertySeletedDetail={setPropertySeletedDetail}
                        propertySelectedDetail={propertySelectedDetail}
                        popover={true}
                        buyerId={buyerId}
                        buyerpropertylist={buyerpropertylist}
                        proid={proid}
                        setProid={setProid}
                        proUniqueId={proUniqueId}
                        setProUniqueId={setProUniqueId}
                        expandAgency={expandAgency}
                        index={2}
                        handlepropertyClose={handlepropertyClose}
                        handleChangePaAddressTwo={handleChangePaAddressTwo}
                        selectedPaBlue={selectedPaBlue}
                        setSelectedPaBlue={setSelectedPaBlue}
                      />
                    </TabPanel>
                  </div>
                </Popover>
              </Grid>
            </Popover>
          )}
          {!matchessm && (
            <Grid
              item
              style={{
                display: 'flex',
                flexDirection: expand && show && shrink ? 'column' : 'row',
              }}
            >
              {expand && show && shrink ? (
                <>
                  <Grid
                    item
                    container
                    sx={{
                      width: '367px',
                      border: '1px solid yellow',
                      bgcolor: '#FFFFFF',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      overflowY: 'scroll',
                      '-webkit-scrollbar': {
                        display: 'none',
                      },
                      '-ms-overflow-style': 'none' /* IE and Edge */,
                      'scrollbar-width': 'none',
                    }}
                  >
                    <Grid
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        marginTop: '10px',
                      }}
                    >
                      <BuyerCardProfile
                        setLoading={setLoading}
                        loading={loading}
                        count={count}
                        showBackdrop={showBackdrop}
                        selectedBuyers={selectedBuyers}
                        setSelectedBuyers={setSelectedBuyers}
                        onClose={() => setOpen(false)}
                        setSelectedBuyerId={setSelectedBuyerId}
                        selectedBuyerId={selectedBuyerId}
                        openOwner={openOwner}
                        setOpenOwner={setOpenOwner}
                        open={open}
                        setOpen={setOpen}
                        userType={userType}
                        buyerId={buyerId}
                        onClick={handleExpand}
                        setExpand={setExpand}
                        expand={expand}
                        marketShow={marketShow}
                        setMarketShow={setMarketShow}
                        show={show}
                        setShow={setShow}
                        setIsHiddenRightArrow={setIsHiddenRightArrow}
                        isHiddenRightArrow={isHiddenRightArrow}
                        position={position}
                        arrayCollection={arrayCollection}
                        data={data}
                        setBuyerId={setBuyerId}
                        setPosition={setPosition}
                        setArrayCollection={setArrayCollection}
                        setUserType={setUserType}
                        rowData={rowData}
                        buyerName={buyerName}
                        setBuyerName={setBuyerName}
                        fromSearch={fromSearch}
                        catSelected={catSelected}
                        noteSelected={noteSelected}
                        taskId={taskId}
                        taskBinderId={taskBinderId}
                        proid={proid}
                      />
                      {!expand && !loading && (
                        <Box sx={{ width: '340px' }}>
                          <LiveActivityFeed
                            ownercardprop={ownercardprop}
                            buyerId={buyerId}
                            agentindividual={true}
                            rowData={rowData}
                            proid={proid}
                          />
                        </Box>
                      )}

                      {!expand && !loading && (
                        <Grid
                          sx={{
                            display: 'flex',
                            marginLeft: '75px',
                            padding: '20px',
                            width: '209px',
                            marginBottom: '20px',
                          }}
                        >
                          <Typography sx={displayFlex} style={{ gap: '20px' }}>
                            <Typography style={{ paddingRight: '10px' }}>
                              <Button
                                sx={{
                                  ...poppins400,
                                  fontSize: '12px',
                                  color: '#6C2AD2',
                                  bgcolor: 'rgba(108, 42, 210, 0.1)',
                                  borderRadius: '4.05125px',
                                  height: '30px',
                                }}
                              >
                                Feedback
                              </Button>
                            </Typography>
                            <Typography>
                              <Select
                                sx={{
                                  ...poppins500,
                                  fontSize: '12px',
                                  color: '#6C2AD2',
                                  border: '1px solid #6C2AD2',
                                  marginLeft: '10px',
                                  height: '30px',
                                  background: '#FFFFFF',
                                  boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)',
                                  borderRadius: '5px',
                                  '& .MuiOutlinedInput-notchedOutline': {
                                    border: 'none',
                                  },
                                }}
                                size="small"
                                value="10"
                                style={{
                                  padding: '0px 2px',
                                }}
                                onChange={() => {}}
                                displayEmpty
                                inputProps={{ 'aria-label': 'Without label' }}
                              >
                                <MenuItem value={10}>Action</MenuItem>
                                <MenuItem value={20}>Twenty</MenuItem>
                                <MenuItem value={30}>Thirty</MenuItem>
                              </Select>
                            </Typography>
                          </Typography>
                        </Grid>
                      )}
                      {expand && (
                        <>
                          <Stack
                            sx={{
                              marginLeft: '13px',
                              padding: '15px',
                              border: '1px solid #E7E5E5',
                              borderRadius: '10px',
                              width: '340px',
                              height: '218px',
                            }}
                          >
                            <Stack
                              sx={{
                                width: '296px',
                                height: '38px',
                                background: '#F7F8F7',

                                borderRadius: '6px',

                                marginTop: '2px',
                                marginLeft: '3px',
                                marginRight: '10px',
                                padding: '8px 12px',
                              }}
                              direction="row"
                              align-items="flex-start"
                            >
                              <Typography
                                sx={{
                                  textAlign: 'center',
                                  fontFamily: 'Poppins !important',
                                  fontStyle: 'normal !important',
                                  fontWeight: '500 !important',
                                  fontSize: '14px',
                                  marginLeft: '15px',
                                }}
                              >
                                Activity Overview
                              </Typography>
                            </Stack>

                            <Card
                              onClick={() => {
                                setMarketShow(false);
                                setPropertyColor(
                                  show === true ? '#000000' : '#6C2AD2'
                                );
                              }}
                              sx={{
                                width: '296px',
                                height: '60px',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                background: '#FFFFFF',
                                paddingLeft: '10px',
                                paddingRight: '10px',
                                boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.15)',
                                marginTop: '10px',

                                padding: '8px 15px',
                                borderLeftStyle:
                                  marketShow !== true ? 'solid' : '',
                                borderLeftColor:
                                  marketShow !== true ? '#6C2AD2' : '',
                              }}
                            >
                              <Stack>
                                <Stack
                                  direction={'row'}
                                  padding={'8px 15px'}
                                  color={'#6C2AD2'}
                                >
                                  <Home
                                    color={
                                      marketShow !== true
                                        ? '#6C2AD2'
                                        : '#666666'
                                    }
                                  />
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '500 !important',
                                      fontSize: '14px',
                                      color:
                                        marketShow !== true
                                          ? '#6C2AD2'
                                          : '#666666',
                                      padding: '5px 15px',
                                      cursor: 'pointer',
                                    }}
                                  >
                                    Properties
                                  </Typography>
                                </Stack>
                              </Stack>
                            </Card>
                            <Card
                              onClick={() => {
                                setMarketShow(!marketShow);
                                setMarketColor(
                                  marketShow === true ? '#6C2AD2' : '#666666'
                                );
                              }}
                              sx={{
                                width: '296px',
                                height: '60px',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                background: '#FFFFFF',
                                paddingLeft: '10px',
                                paddingRight: '10px',
                                boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.15)',
                                marginTop: '10px',

                                padding: '8px 15px',
                                borderLeftStyle:
                                  marketShow === true ? 'solid' : '',
                                borderLeftColor:
                                  marketShow === true ? '#6C2AD2' : '',
                              }}
                            >
                              <Stack>
                                <Stack direction={'row'} padding={'8px 15px'}>
                                  <MarketIcon
                                    color={
                                      marketShow == true ? '#6C2AD2' : '#666666'
                                    }
                                  />
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '500 !important',
                                      fontSize: '14px',
                                      color:
                                        marketShow === true
                                          ? '#6C2AD2'
                                          : '#666666',
                                      padding: '2px 15px',
                                      cursor: 'pointer',
                                    }}
                                  >
                                    Market
                                  </Typography>
                                </Stack>
                              </Stack>
                            </Card>
                          </Stack>
                        </>
                      )}
                      {expand && (
                        <Box
                          sx={{
                            width: '340px',
                            marginLeft: '13px',
                            marginY: '20px',
                          }}
                        >
                          <MessagingContainer
                            binders={true}
                            ContactUserCard={true}
                            userEmail={emailId}
                            proid={proid}
                          />
                        </Box>
                      )}
                      {((expand && Small) || shrink) && !matches870 && (
                        <Grid
                          item
                          sx={{ marginTop: '15px', marginLeft: '243px' }}
                        >
                          <Button
                            onClick={toggleShow}
                            sx={{
                              background: '#FFFFFF',
                              border: '1px solid #E7E5E5',
                              borderRadius: '5px',
                              color: '#6C2AD2',
                            }}
                          >
                            {buttonText}
                          </Button>
                        </Grid>
                      )}

                      {expand && (
                        <>
                          {show && !matches870 && (
                            <Grid
                              item
                              xs={2.5}
                              display={'flex'}
                              justifyContent={'flex-start'}
                              flexDirection={'column'}
                              alignItems={'center'}
                              sx={{
                                marginTop: '75px',
                                marginLeft: matches1600 ? '10px' : '20px',
                                minWidth: '364px',
                              }}
                            >
                              <div
                                style={{ width: matches450 ? '90%' : '100%' }}
                              >
                                <Box
                                  sx={{
                                    width: '100%',
                                    bgcolor: 'background.paper',

                                    height: '24px',
                                  }}
                                >
                                  <Tabs
                                    value={propertyValue}
                                    onChange={handlePropertyChange}
                                    aria-label=" tabs example"
                                    centered
                                    sx={{
                                      '& .MuiTabs-indicator': {
                                        display: 'none',
                                      },
                                      '& .MuiTab-root.Mui-selected': {
                                        background: ' #6C2AD2',
                                        borderRadius: '5px',
                                        color: '#FFFFFF',

                                        gap: '10px',
                                      },
                                      '& button.Mui-selected': {
                                        padding:
                                          isXs || Small || isMd
                                            ? 'none'
                                            : '0px 10px',
                                      },
                                    }}
                                  >
                                    <Tab
                                      onClick={() => setExpandAgenct('all')}
                                      style={{
                                        minHeight: '24px',
                                        padding: '0px',
                                      }}
                                      className={classes.tab}
                                      {...propertyProps(1)}
                                      label={
                                        <Typography
                                          sx={{
                                            fontFamily: 'Poppins !important',
                                            fontStyle: 'normal !important',
                                            fontWeight: '400',
                                            fontSize: '16px',
                                          }}
                                        >
                                          All
                                        </Typography>
                                      }
                                    />
                                    <Tab
                                      onClick={() => setExpandAgenct('agency')}
                                      style={{
                                        minHeight: '24px',
                                        padding: '0px',
                                      }}
                                      className={classes.tab}
                                      {...propertyProps(0)}
                                      label={
                                        <Typography
                                          sx={{
                                            fontFamily: 'Poppins !important',
                                            fontStyle: 'normal !important',
                                            fontWeight: '500',
                                            fontSize: '16px',
                                          }}
                                        >
                                          Agency
                                        </Typography>
                                      }
                                    />
                                  </Tabs>
                                </Box>
                                <Tabs
                                  style={{
                                    color: 'purpleHeart',
                                    borderBottom: 'purpleheart',
                                    display: 'false',
                                  }}
                                  value={value}
                                  onChange={handleChange}
                                  variant="fullWidth"
                                  aria-label="full width tabs example"
                                  sx={{
                                    '& .MuiTabs-indicator': {
                                      backgroundColor: '#6C2AD2',
                                      marginBottom: '5px',
                                    },
                                    '& .MuiTab-root.Mui-selected': {
                                      color: '#6C2AD2',
                                      fontWeight: '500',
                                    },
                                  }}
                                >
                                  <Tab
                                    label="All"
                                    {...a11yProps(0)}
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '400 !important',
                                      fontSize: '12px',
                                      textTransform: 'capitalize',
                                    }}
                                  />

                                  <Tab
                                    label="Offers"
                                    {...a11yProps(1)}
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '400 !important',
                                      fontSize: '12px',
                                      textTransform: 'none',
                                    }}
                                  />

                                  <Tab
                                    label="Inspected"
                                    {...a11yProps(2)}
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '400 !important',
                                      fontSize: '12px',
                                      textTransform: 'none',
                                    }}
                                  />
                                </Tabs>
                                <TabPanel value={value} index={0} width="340px">
                                  <BuyersActivities
                                    scrollToTopContainer={scrollToTopContainer}
                                    setBuyerDetailNavigation={
                                      setBuyerCardDetailNavigation
                                    }
                                    setPropertySelected={setPropertySelected}
                                    setPropertySeletedDetail={
                                      setPropertySeletedDetail
                                    }
                                    propertySelectedDetail={
                                      propertySelectedDetail
                                    }
                                    buyerId={buyerId}
                                    expandAgency={expandAgency}
                                    index={0}
                                    buyerpropertylist={buyerpropertylist}
                                    proid={proid}
                                    setProid={setProid}
                                    proUniqueId={proUniqueId}
                                    setProUniqueId={setProUniqueId}
                                    handleChangePaAddressTwo={
                                      handleChangePaAddressTwo
                                    }
                                    selectedPaBlue={selectedPaBlue}
                                    setSelectedPaBlue={setSelectedPaBlue}
                                  />
                                </TabPanel>
                                <TabPanel value={value} index={1}>
                                  <BuyersActivities
                                    scrollToTopContainer={scrollToTopContainer}
                                    setBuyerDetailNavigation={
                                      setBuyerCardDetailNavigation
                                    }
                                    setPropertySelected={setPropertySelected}
                                    setPropertySeletedDetail={
                                      setPropertySeletedDetail
                                    }
                                    propertySelectedDetail={
                                      propertySelectedDetail
                                    }
                                    buyerId={buyerId}
                                    expandAgency={expandAgency}
                                    index={1}
                                    buyerpropertylist={buyerpropertylist}
                                    proid={proid}
                                    setProid={setProid}
                                    proUniqueId={proUniqueId}
                                    setProUniqueId={setProUniqueId}
                                    handleChangePaAddressTwo={
                                      handleChangePaAddressTwo
                                    }
                                    selectedPaBlue={selectedPaBlue}
                                    setSelectedPaBlue={setSelectedPaBlue}
                                  />
                                </TabPanel>
                                <TabPanel value={value} index={2}>
                                  <BuyersActivities
                                    scrollToTopContainer={scrollToTopContainer}
                                    setBuyerDetailNavigation={
                                      setBuyerCardDetailNavigation
                                    }
                                    setPropertySelected={setPropertySelected}
                                    setPropertySeletedDetail={
                                      setPropertySeletedDetail
                                    }
                                    propertySelectedDetail={
                                      propertySelectedDetail
                                    }
                                    buyerId={buyerId}
                                    expandAgency={expandAgency}
                                    index={2}
                                    buyerpropertylist={buyerpropertylist}
                                    proid={proid}
                                    setProid={setProid}
                                    proUniqueId={proUniqueId}
                                    setProUniqueId={setProUniqueId}
                                    handleChangePaAddressTwo={
                                      handleChangePaAddressTwo
                                    }
                                    selectedPaBlue={selectedPaBlue}
                                    setSelectedPaBlue={setSelectedPaBlue}
                                  />
                                </TabPanel>
                              </div>
                            </Grid>
                          )}
                        </>
                      )}
                    </Grid>
                  </Grid>
                </>
              ) : (
                <>
                  <Grid
                    item
                    container
                    sx={{
                      width: matches450 ? '100%' : '364px',
                      bgcolor: '#FFFFFF',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      overflowY: 'scroll',
                      '-webkit-scrollbar': {
                        display: 'none',
                      },
                      '-ms-overflow-style': 'none' /* IE and Edge */,
                      'scrollbar-width': 'none',
                    }}
                  >
                    <Grid
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        marginTop: '10px',
                      }}
                    >
                      <BuyerCardProfile
                        setLoading={setLoading}
                        loading={loading}
                        count={count}
                        showBackdrop={showBackdrop}
                        selectedBuyers={selectedBuyers}
                        setSelectedBuyers={setSelectedBuyers}
                        onClose={() => setOpen(false)}
                        setSelectedBuyerId={setSelectedBuyerId}
                        selectedBuyerId={selectedBuyerId}
                        openOwner={openOwner}
                        setOpenOwner={setOpenOwner}
                        open={open}
                        setOpen={setOpen}
                        userType={userType}
                        buyerId={buyerId}
                        onClick={handleExpand}
                        setExpand={setExpand}
                        expand={expand}
                        marketShow={marketShow}
                        setMarketShow={setMarketShow}
                        show={show}
                        setShow={setShow}
                        setIsHiddenRightArrow={setIsHiddenRightArrow}
                        isHiddenRightArrow={isHiddenRightArrow}
                        position={position}
                        arrayCollection={arrayCollection}
                        data={data}
                        setBuyerId={setBuyerId}
                        setPosition={setPosition}
                        setArrayCollection={setArrayCollection}
                        setUserType={setUserType}
                        rowData={rowData}
                        buyercard={true}
                        buyerName={buyerName}
                        setBuyerName={setBuyerName}
                        fromSearch={fromSearch}
                        catSelected={catSelected}
                        noteSelected={noteSelected}
                        taskId={taskId}
                        taskBinderId={taskBinderId}
                        proid={proid}
                      />

                      {!expand && !loading && (
                        <Box
                          sx={{
                            width: '340px',
                            marginLeft: matches450 && '-15px',
                          }}
                        >
                          <LiveActivityFeed
                            ownercardprop={ownercardprop}
                            buyerId={buyerId}
                            agentindividual={true}
                            rowData={rowData}
                            proid={proid}
                            buyercard={true}
                          />
                        </Box>
                      )}

                      {!expand && !loading && (
                        <Grid
                          sx={{
                            display: 'flex',
                            marginLeft: '75px',
                            padding: '20px',
                            width: '209px',
                            marginBottom: '20px',
                          }}
                        >
                          <Typography sx={displayFlex} style={{ gap: '20px' }}>
                            <Typography style={{ paddingRight: '10px' }}>
                              <Button
                                onClick={() => {
                                  setOpenFeedback(true);
                                }}
                                sx={{
                                  ...poppins400,
                                  fontSize: '12px',
                                  color: '#6C2AD2',
                                  bgcolor: 'rgba(108, 42, 210, 0.1)',
                                  borderRadius: '4.05125px',
                                  height: '30px',
                                }}
                              >
                                Feedback
                              </Button>
                            </Typography>
                            <Typography>
                              <Select
                                sx={{
                                  ...poppins500,
                                  fontSize: '12px',
                                  color: '#6C2AD2',
                                  border: '1px solid #6C2AD2',
                                  marginLeft: '10px',
                                  height: '30px',
                                  background: '#FFFFFF',
                                  boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)',
                                  borderRadius: '5px',
                                  '& .MuiOutlinedInput-notchedOutline': {
                                    border: 'none',
                                  },
                                }}
                                size="small"
                                value="10"
                                style={{
                                  padding: '0px 2px',
                                }}
                                onChange={() => {}}
                                displayEmpty
                                inputProps={{ 'aria-label': 'Without label' }}
                              >
                                <MenuItem value={10}>Action</MenuItem>
                                <MenuItem value={20}>Twenty</MenuItem>
                                <MenuItem value={30}>Thirty</MenuItem>
                              </Select>
                            </Typography>
                          </Typography>
                        </Grid>
                      )}
                      {expand && (
                        <>
                          <Stack
                            sx={{
                              marginLeft: '13px',
                              padding: '15px',
                              border: '1px solid #E7E5E5',
                              borderRadius: '10px',
                              width: '340px',
                              height: '218px',
                            }}
                          >
                            <Stack
                              sx={{
                                width: '296px',
                                height: '38px',
                                background: '#F7F8F7',

                                borderRadius: '6px',

                                marginTop: '2px',
                                marginLeft: '3px',
                                marginRight: '10px',
                                padding: '8px 12px',
                              }}
                              direction="row"
                              align-items="flex-start"
                            >
                              <Typography
                                sx={{
                                  textAlign: 'center',
                                  fontFamily: 'Poppins !important',
                                  fontStyle: 'normal !important',
                                  fontWeight: '500 !important',
                                  fontSize: '14px',
                                  marginLeft: '15px',
                                }}
                              >
                                Activity Overview
                              </Typography>
                            </Stack>

                            <Card
                              onClick={() => {
                                setMarketShow(false);
                                setPropertyColor(
                                  show === true ? '#000000' : '#6C2AD2'
                                );
                              }}
                              sx={{
                                width: '296px',
                                height: '60px',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                background: '#FFFFFF',
                                paddingLeft: '10px',
                                paddingRight: '10px',
                                boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.15)',
                                marginTop: '10px',

                                padding: '8px 15px',
                                borderLeftStyle:
                                  marketShow !== true ? 'solid' : '',
                                borderLeftColor:
                                  marketShow !== true ? '#6C2AD2' : '',
                              }}
                            >
                              <Stack>
                                <Stack
                                  direction={'row'}
                                  padding={'8px 15px'}
                                  color={'#6C2AD2'}
                                >
                                  <Home
                                    color={
                                      marketShow !== true
                                        ? '#6C2AD2'
                                        : '#666666'
                                    }
                                  />
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '500 !important',
                                      fontSize: '14px',
                                      color:
                                        marketShow !== true
                                          ? '#6C2AD2'
                                          : '#666666',
                                      padding: '5px 15px',
                                      cursor: 'pointer',
                                    }}
                                  >
                                    Properties
                                  </Typography>
                                </Stack>
                              </Stack>
                            </Card>
                            <Card
                              onClick={() => {
                                setMarketShow(!marketShow);
                                setMarketColor(
                                  marketShow === true ? '#6C2AD2' : '#666666'
                                );
                              }}
                              sx={{
                                width: '296px',
                                height: '60px',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                background: '#FFFFFF',
                                paddingLeft: '10px',
                                paddingRight: '10px',
                                boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.15)',
                                marginTop: '10px',

                                padding: '8px 15px',
                                borderLeftStyle:
                                  marketShow === true ? 'solid' : '',
                                borderLeftColor:
                                  marketShow === true ? '#6C2AD2' : '',
                              }}
                            >
                              <Stack>
                                <Stack direction={'row'} padding={'8px 15px'}>
                                  <MarketIcon
                                    color={
                                      marketShow == true ? '#6C2AD2' : '#666666'
                                    }
                                  />
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '500 !important',
                                      fontSize: '14px',
                                      color:
                                        marketShow === true
                                          ? '#6C2AD2'
                                          : '#666666',
                                      padding: '2px 15px',
                                      cursor: 'pointer',
                                    }}
                                  >
                                    Market
                                  </Typography>
                                </Stack>
                              </Stack>
                            </Card>
                          </Stack>
                        </>
                      )}
                      {expand && (
                        <Box
                          sx={{
                            width: '340px',
                            marginLeft: '13px',
                            marginY: '20px',
                          }}
                        >
                          <MessagingContainer
                            binders={true}
                            ContactUserCard={true}
                            userEmail={emailId}
                            proid={proid}
                          />
                        </Box>
                      )}
                      {expand && (Small || shrink) && !matches870 && (
                        <Grid
                          item
                          sx={{ marginTop: '15px', marginLeft: '243px' }}
                        >
                          <Button
                            onClick={toggleShow}
                            sx={{
                              background: '#FFFFFF',
                              border: '1px solid #E7E5E5',
                              borderRadius: '5px',
                              color: '#6C2AD2',
                            }}
                          >
                            {buttonText}
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                  {expand && (
                    <>
                      {show && (
                        <Grid
                          item
                          xs={2.5}
                          display={'flex'}
                          justifyContent={'flex-start'}
                          flexDirection={'column'}
                          alignItems={'center'}
                          sx={{
                            marginTop: isSm
                              ? '30px'
                              : expand && show && window.innerWidth < 1800
                              ? '50px'
                              : '75px',
                            marginLeft: isSm ? '140px' : '20px',
                            minWidth: '364px',
                            overflowY: 'scroll',
                            '-webkit-scrollbar': {
                              display: 'none',
                            },
                            '-ms-overflow-style': 'none' /* IE and Edge */,
                            'scrollbar-width': 'none',
                          }}
                        >
                          <div style={{ width: '100%' }}>
                            <Box
                              sx={{
                                width: '100%',
                                bgcolor: 'background.paper',

                                height: '24px',
                              }}
                            >
                              <Tabs
                                value={propertyValue}
                                onChange={handlePropertyChange}
                                aria-label=" tabs example"
                                centered
                                sx={{
                                  '& .MuiTabs-indicator': { display: 'none' },
                                  '& .MuiTab-root.Mui-selected': {
                                    background: ' #6C2AD2',
                                    borderRadius: '5px',
                                    color: '#FFFFFF',

                                    gap: '10px',
                                  },
                                  '& button.Mui-selected': {
                                    padding:
                                      isXs || Small || isMd
                                        ? 'none'
                                        : '0px 10px',
                                  },
                                }}
                              >
                                <Tab
                                  onClick={() => setExpandAgenct('all')}
                                  style={{ minHeight: '24px', padding: '0px' }}
                                  className={classes.tab}
                                  {...propertyProps(1)}
                                  label={
                                    <Typography
                                      sx={{
                                        fontFamily: 'Poppins !important',
                                        fontStyle: 'normal !important',
                                        fontWeight: '400',
                                        fontSize: '16px',
                                      }}
                                    >
                                      All
                                    </Typography>
                                  }
                                />
                                <Tab
                                  onClick={() => setExpandAgenct('agency')}
                                  style={{ minHeight: '24px', padding: '0px' }}
                                  className={classes.tab}
                                  {...propertyProps(0)}
                                  label={
                                    <Typography
                                      sx={{
                                        fontFamily: 'Poppins !important',
                                        fontStyle: 'normal !important',
                                        fontWeight: '500',
                                        fontSize: '16px',
                                      }}
                                    >
                                      Agency
                                    </Typography>
                                  }
                                />
                              </Tabs>
                            </Box>
                            <Tabs
                              style={{
                                color: 'purpleHeart',
                                borderBottom: 'purpleheart',
                                display: 'false',
                              }}
                              value={value}
                              onChange={handleChange}
                              variant="fullWidth"
                              aria-label="full width tabs example"
                              sx={{
                                '& .MuiTabs-indicator': {
                                  backgroundColor: '#6C2AD2',
                                  marginBottom: '5px',
                                },
                                '& .MuiTab-root.Mui-selected': {
                                  color: '#6C2AD2',
                                  fontWeight: '500',
                                },
                              }}
                            >
                              <Tab
                                label="All"
                                {...a11yProps(0)}
                                sx={{
                                  fontFamily: 'Poppins !important',
                                  fontStyle: 'normal !important',
                                  fontWeight: '400 !important',
                                  fontSize: '12px',
                                  textTransform: 'capitalize',
                                }}
                              />

                              <Tab
                                label="Offers"
                                {...a11yProps(1)}
                                sx={{
                                  fontFamily: 'Poppins !important',
                                  fontStyle: 'normal !important',
                                  fontWeight: '400 !important',
                                  fontSize: '12px',
                                  textTransform: 'none',
                                }}
                              />

                              <Tab
                                label="Inspected"
                                {...a11yProps(2)}
                                sx={{
                                  fontFamily: 'Poppins !important',
                                  fontStyle: 'normal !important',
                                  fontWeight: '400 !important',
                                  fontSize: '12px',
                                  textTransform: 'none',
                                }}
                              />
                            </Tabs>
                            <TabPanel value={value} index={0} width="340px">
                              <BuyersActivities
                                scrollToTopContainer={scrollToTopContainer}
                                setBuyerDetailNavigation={
                                  setBuyerCardDetailNavigation
                                }
                                setPropertySelected={setPropertySelected}
                                setPropertySeletedDetail={
                                  setPropertySeletedDetail
                                }
                                propertySelectedDetail={propertySelectedDetail}
                                buyerId={buyerId}
                                expandAgency={expandAgency}
                                index={0}
                                buyerpropertylist={buyerpropertylist}
                                proid={proid}
                                setProid={setProid}
                                proUniqueId={proUniqueId}
                                setProUniqueId={setProUniqueId}
                                handleChangePaAddressTwo={
                                  handleChangePaAddressTwo
                                }
                                selectedPaBlue={selectedPaBlue}
                                setSelectedPaBlue={setSelectedPaBlue}
                              />
                            </TabPanel>
                            <TabPanel value={value} index={1}>
                              <BuyersActivities
                                scrollToTopContainer={scrollToTopContainer}
                                setBuyerDetailNavigation={
                                  setBuyerCardDetailNavigation
                                }
                                setPropertySelected={setPropertySelected}
                                setPropertySeletedDetail={
                                  setPropertySeletedDetail
                                }
                                propertySelectedDetail={propertySelectedDetail}
                                buyerId={buyerId}
                                expandAgency={expandAgency}
                                index={1}
                                buyerpropertylist={buyerpropertylist}
                                proid={proid}
                                setProid={setProid}
                                proUniqueId={proUniqueId}
                                setProUniqueId={setProUniqueId}
                                handleChangePaAddressTwo={
                                  handleChangePaAddressTwo
                                }
                                selectedPaBlue={selectedPaBlue}
                                setSelectedPaBlue={setSelectedPaBlue}
                              />
                            </TabPanel>
                            <TabPanel value={value} index={2}>
                              <BuyersActivities
                                scrollToTopContainer={scrollToTopContainer}
                                setBuyerDetailNavigation={
                                  setBuyerCardDetailNavigation
                                }
                                setPropertySelected={setPropertySelected}
                                setPropertySeletedDetail={
                                  setPropertySeletedDetail
                                }
                                propertySelectedDetail={propertySelectedDetail}
                                buyerId={buyerId}
                                expandAgency={expandAgency}
                                index={2}
                                buyerpropertylist={buyerpropertylist}
                                proid={proid}
                                setProid={setProid}
                                proUniqueId={proUniqueId}
                                setProUniqueId={setProUniqueId}
                                handleChangePaAddressTwo={
                                  handleChangePaAddressTwo
                                }
                                selectedPaBlue={selectedPaBlue}
                                setSelectedPaBlue={setSelectedPaBlue}
                              />
                            </TabPanel>
                          </div>
                        </Grid>
                      )}
                    </>
                  )}
                </>
              )}
            </Grid>
          )}

          {expand && !matches870 && !isSm && (
            <Grid
              item={8}
              flexGrow={1}
              sx={{
                overflowY: 'scroll',
                '-webkit-scrollbar': {
                  display: 'none',
                },
                '-ms-overflow-style': 'none' /* IE and Edge */,
                'scrollbar-width': 'none',
              }}
            >
              <ExpandedBuyersCard
                isSmall={isSm}
                marketShow={marketShow}
                expandFeedback={expandFeedback}
                setExpandFeedback={setExpandFeedback}
                propertyValue={propertyValue}
                show={show}
                setShow={setShow}
                expand={expand}
                shrink={shrink}
                rowData={rowData}
                buyerId={buyerId}
                ownercardprop={ownercardprop}
                activitywidth
                buyercardcontact
                buyerpropertylist={buyerpropertylist}
                proid={proid}
                setProid={setProid}
                userEmail={emailId}
                userType={userType}
                proUniqueId={proUniqueId}
                setProUniqueId={setProUniqueId}
                setExpand={setExpand}
                buyercard={true}
                selectedPaAddressTwo={selectedPaAddressTwo}
                setSelectedPaAddressTwo={setSelectedPaAddressTwo}
                handleBlueline={handleBlueline}
                setIsPipelineCat={setIsPipelineCat}
                setPipelineCat={setPipelineCat}
                setPipelineId={setPipelineId}
                setIsAppraisal={setIsAppraisal}
                fromSearch={fromSearch}
                catSelected={catSelected}
                noteSelected={noteSelected}
                taskId={taskId}
                taskBinderId={taskBinderId}
              />
            </Grid>
          )}
        </Stack>
      </Dialog>

      {(expandFeedback || openFeedback) && (
        <Grid sx={{ marginLeft: '20px' }}>
          <Feedback
            buyerCardOpen={userType === 'Buyer' ? open : openOwner}
            setBuyerCardOpen={userType === 'Buyer' ? setOpen : setOpenOwner}
            userEmail={rowData?.userEmail}
            userType={rowData?.userCategory[0]?.userType}
            address={address}
            data={rowData}
            userName={`${rowData?.user?.userName} ${rowData?.user?.userSurName}`}
            buyerId={buyerId}
            proid={proid}
            expandFeedback={expandFeedback}
            setExpandFeedback={setExpandFeedback}
            openFeedback={openFeedback}
            setOpenFeedback={setOpenFeedback}
            open={open}
            setOpen={setOpen}
            proUniqueId={proid}
            propertyUniqueId={proUniqueId}
            buyerpropertylist={buyerpropertylist}
            marketShow={false}
            row={rowData}
            ownercardprop={userType == 'Vendor' ? true : false}
            directcomm={directcomm}
            index={null}
            setAddress={setAddress}
            userInitial={`${rowData?.user?.userName?.trim()?.charAt(0) || ''}${
              rowData?.user?.userSurName?.trim()?.charAt(0) || ''
            }`.toUpperCase()}
          />
        </Grid>
      )}
    </>
  );
};
